import actionTypes from 'constants/actionTypes';
import apiURLBuilder from 'core/apiURLBuilder';
import { APIGet } from 'utilities/APIRequestHelper';

const requestPredictionMarketsSuccess = response => {
    return {
        type: actionTypes.BROKER_IA_GET_PREDICTION_MARKETS_SUCCESS,
        payload: {
            data: response,
        },
    };
};

const requestPredictionMarketsFetching = () => {
    return {
        type: actionTypes.BROKER_IA_GET_PREDICTION_MARKETS_FETCHING,
    };
};

const requestPredictionMarketsFailure = response => {
    return {
        type: actionTypes.BROKER_IA_GET_PREDICTION_MARKETS_FAILURE,
        payload: {
            data: response,
        },
    };
};

const getPredictionMarketsAction = (
    dispatch,
    params,
    predictionMarkets = 'brokerIAPredictionMarkets'
) => {
    const requestData = { query: { ...params } };

    dispatch(requestPredictionMarketsFetching());

    return APIGet(dispatch, apiURLBuilder.getURL(predictionMarkets), requestData)
        .then(response => {
            dispatch(requestPredictionMarketsSuccess(response));
        })
        .catch(response => {
            dispatch(requestPredictionMarketsFailure(response));
        });
};

const getPredictionMarkets = filtersParams => dispatch =>
    getPredictionMarketsAction(dispatch, filtersParams);

module.exports = {
    getPredictionMarkets,
    getPredictionMarketsAction,
};
